export const normalizeSentiment = (value: number | null) => {
  if (value === null) return Number(0);
  let normalized = value - 5;
  const clamped = Math.max(-5, Math.min(5, normalized));
  return Number(clamped.toFixed(2));
};
